import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20v-10a6 6 0 0 1 6 -6h10","key":"svg-0"}]]

/**
 * IconBorderCornerRounded
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYm9yZGVyLWNvcm5lci1yb3VuZGVkIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDIwdi0xMGE2IDYgMCAwIDEgNiAtNmgxMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/border-corner-rounded
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBorderCornerRounded = createReactComponent('outline', 'border-corner-rounded', 'BorderCornerRounded', __iconNode);

export default IconBorderCornerRounded;